/**
 * @author Radek Liška <ing.radek.liska@gmail.com>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

import isArray from 'lodash/isArray';

import ScheduleLinear from './schedule-linear';

/**
 * Statická strategie přehrávání.
 * Řízení přehrávání založené na pořadí stop v rámci playlistu.
 * @implements {ScheduleStrategy}
 */
class ScheduleStatic {
  /**
   * Vytvoří instanci.
   * @param {ContentInfo} contentInfo Informace o obsahu zařízení.
   * @param {Playlist} playlist Playlist pro aplikaci strategie.
   * @param {Array.<Track>} trackArray Seznam stop playlistu pro aplikaci strategie. Na pořadí nezáleží.
   * @param {ViewerRegistry} viewerRegistry Registr informací o typech médií.
   * @returns {ScheduleStatic} Nová instance.
   */
  constructor(contentInfo, playlist, trackArray, viewerRegistry) {
    if (!isArray(trackArray)) {
      throw new TypeError(`Invalid track array ${trackArray}.`);
    }
    const sortedTrackArray = trackArray.sort((a, b) => a.index - b.index);
    this.scheduleLinear = new ScheduleLinear(
      contentInfo,
      playlist,
      sortedTrackArray,
      viewerRegistry
    );
  }

  /** @inheritdoc */
  destroy() {
    this.scheduleLinear.destroy();
  }

  /** @inheritdoc */
  go() {
    return this.scheduleLinear.go();
  }

  /** @inheritdoc */
  off(...args) {
    this.scheduleLinear.off(...args);
  }

  /** @inheritdoc */
  on(...args) {
    this.scheduleLinear.on(...args);
  }

  /** @inheritdoc */
  plan(offset) {
    return this.scheduleLinear.plan(offset);
  }

  /** @inheritdoc */
  skip() {
    this.scheduleLinear.skip();
  }

  /** @inheritdoc */
  stop() {
    this.scheduleLinear.stop();
  }

  /** @inheritdoc */
  toString() {
    return `ScheduleStatic {playlist: ${this.scheduleLinear.playlist}}`;
  }
}

export default ScheduleStatic;
